export const calibrationConfig = Object.freeze({
  laptop: {
    faceStabilityMs: 2000,
    cameraStartTimeoutMs: 8000,
    frameSamplingIntervalMs: 750,
    minimumVideoWidth: 320,
    minimumVideoHeight: 240,
    lowBrightnessThreshold: 38,
    overexposureThreshold: 235,
    obstructionConfirmationMs: 1500
  },
  mobile: {
    cameraStartTimeoutMs: 10_000,
    frameSamplingIntervalMs: 900,
    minimumVideoWidth: 320,
    minimumVideoHeight: 240,
    lowBrightnessThreshold: 32,
    overexposureThreshold: 240,
    obstructionConfirmationMs: 1800,
    stabilityDurationMs: 2200,
    stableFrameDifferenceThreshold: 32
  },
  connectionReadinessTimeoutMs: 12_000,
  retryDelayMs: 500,
  publicDemo: {
    microphoneRequired: true,
    mobileCameraRequired: false
  }
});

export type CalibrationState = 'checking' | 'passed' | 'needs_attention' | 'failed' | 'not_required';

export interface CalibrationItem {
  key: string;
  label: string;
  state: CalibrationState;
  mandatory: boolean;
  guidance: string;
}

export function mandatoryCalibrationPassed(items: CalibrationItem[], ignoreConnection = false): boolean {
  return items.length > 0 && items.every((item) =>
    (ignoreConnection && item.key === 'connection') ||
    !item.mandatory ||
    item.state === 'passed' ||
    item.state === 'not_required'
  );
}
